import request from '@/util/request';
import qs from 'qs';
import {getToken} from '@/util/auth';
import website from '@/config/website';
// export const getList = (params, options) =>
// request.get('/api/v4ward/order/listPage', Object.assign({}, options, { params }));
export const getList = (params, options) =>
  request.get('/api/v4ward/order/getOrderListPage', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/order/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
  request.post('/api/v4ward/order/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/order/submit', params, options)

export const update = (params, options) =>
  request.post('/api/v4ward/order/submit', params, options)

// 获取项目下拉框
export const getprojectList = (params, options) =>
  request.get('/api/v4ward/project/getProjectList', Object.assign({}, options, { params }));

// 获取按钮
export const getOrderactionlist = (params, options) =>
  request.get('/api/v4ward/ordersetting/action/orderactionlist', Object.assign({}, options, { params }));

// 字典
export const getDictData = (params, options) =>
  request.get('/api/blade-system/dict/dictionary?code=' + params, Object.assign({}, options, { params }));
// 懒加载区域树
export const lazyAreaTree = (params, options) =>
  request.get('/api/v4ward/area/lazyTree', Object.assign({}, options, { params }));
// 历程
export const getCourseLog = (params, options) =>
  request.get('/api/v4ward/order/operationrecord/log/' + params)

// 获取工单详情
export const getOrderDetail = (params, options) =>
  request.get('/api/v4ward/order/details/' + params)

//  获取群组id
export const getGroupName = (params, options) =>
  request.get('/api/v4ward/order/execute/getGroupDetails', Object.assign({}, options, { params }));

// 获取群组下的人员
// /client/order/getGroupDetails
export const getMenberUserList = (params, options) =>
  request.get('/api/v4ward/order/getGroupDetails', Object.assign({}, options, { params }));

// 获取群组下的人员新  v4ward/order/execute/getGroupDetails
export const getGroupDetails = (params, options) =>
  request.get('/api/v4ward/order/execute/getGroupDetails', Object.assign({}, options, { params }));

// 获取群组下的人员新  v4ward/order/execute/getGroupDetails
export const getGroupDetailsNew = (params, options) =>
  request.get('/api/v4ward/order/getGroupDetails', Object.assign({}, options, { params }));

// 获取协同人列表 v4ward/order/execute/getCooperateList
export const getCooperateList = (params, options) =>
  request.get('/api/v4ward/order/execute/getCooperateList', Object.assign({}, options, { params }));

// 设置协同人 v4ward/order/execute/setCooperate
export const setCooperate = (params, options) =>
  request.post('/api/v4ward/order/execute/setCooperate', params, options,{ContentType:'application/json'});

// 需求人员
export const getUserListByDepartmentId = (params, options) =>
  request.get('/api/v4ward/user/dept-user-list', Object.assign({}, options, { params }));

// 获取备注模板
export const getRemarkList = (params, options) =>
  request.get('/api/v4ward/order/execute/remarkList', Object.assign({}, options, { params }));

// 下载文件接口
export const downloadFile = (fileUrl, fileName) => {
  var url = `/api/v4ward/oss/customEndpoint/downloadFile?${
    website.tokenHeader
  }=${getToken()}` + "&fileUrl=" + fileUrl + "&fileName=" + fileName;
  var a = document.createElement('a');           // 创建隐藏的可下载链接
  a.download = fileName;
  a.style.display = 'none';
  a.href = url;
  document.body.appendChild(a);
  a.click();                                                       // 触发点击
  document.body.removeChild(a);                  // 然后移除
}

// 工单指派
export const appoint = (params, options) =>
  request.post('/api/v4ward/order/execute/appoint', params, options)
// 工单抢单
export const grabSingle = (params, options) =>
  request.post('/api/v4ward/order/execute/grabSingle', params, options)
// 工单取消
export const cancel = (params, options) =>
  request.post('/api/v4ward/order/execute/cancel', params, options)
// 工单打印
export const print = (params, options) =>
  request.get('/api/v4ward/order/execute/print', Object.assign({}, options, { params }))
// 工单接受
export const accept = (params, options) =>
  request.post('/api/v4ward/order/execute/accept', params, options)
// 工单开始
export const start = (params, options) =>
  request.post('/api/v4ward/order/execute/start', params, options)
// 工单延迟
export const delay = (params, options) =>
  request.post('/api/v4ward/order/execute/delay', params, options)
// 工单恢复
export const recover = (params, options) =>
  request.post('/api/v4ward/order/execute/recover', params, options)
// 工单完成
export const finish = (params, options) =>
  request.post('/api/v4ward/order/execute/finish', params, options)
// 工单评价
export const evaluation = (params, options) =>
  request.post('/api/v4ward/order/execute/evaluation', params, options)
// 工单报修
export const repairs = (params, options) =>
  request.post('/api/v4ward/order/execute/repairs', params, options)
// 工单报废
export const scrap = (params, options) =>
  request.post('/api/v4ward/order/execute/scrap', params, options)
// 工单外委
export const outsourcing = (params, options) =>
  request.post('/api/v4ward/order/execute/outsourcing', params, options)

// 获取合同列表
export const getContractList = (params, options) =>
  request.get('/api/v4ward/contract/getList', Object.assign({}, options, { params }));

// 工单转办
export const complaint = (params, options) =>
  request.post('/api/v4ward/order/execute/complaint', params,options)

//  工单确认 /v4ward/order/execute/confirm
export const confirm = (params, options) =>
  request.post('/api/v4ward/order/execute/confirm', params,options)

// 工单回访 /v4ward/order/execute/returnVisit
export const returnVisit = (params, options) =>
  request.post('/api/v4ward/order/execute/returnVisit', params,options)

// 工单催办 /v4ward/order/execute/urge
export const urge = (params, options) =>
  request.post('/api/v4ward/order/execute/urge', params,options)
// 工单打印
export const getOrderWorkStatusSum = (params, options) =>
  request.get('/api/v4ward/order/getOrderWorkStatusSum', Object.assign({}, options, { params }))

/**
 * 根据工单id获取班组列表
 * @param {*} orderId 工单id
 */
export const getGroupList = (params, options) =>
  request.get('/api/v4ward/order/execute/getOrderSubModuleGroupList', Object.assign({}, options, { params }))
/**
 * 根据班组(群组)id获取班组详情
 * @param {*} groupId  群组id
 */
export const getGroupUser = (params, options) =>
  request.get('/api/v4ward/order/execute/getGroupUserByGroupId', Object.assign({}, options, { params }))






















// 根据区域id获取科室详情信息
export const getDeptDetailByAreaId = (params, options) =>
  request.get('/api/client/area/getDeptDetailByAreaId', Object.assign({}, options, { params }))


// 根据科室获取当前科室所有人
export const getDeptUserListByDeptId = (params, options) =>
  request.get('/api/blade-auth/app/getDeptUserListByDeptId', Object.assign({}, options, { params }))

// 获取当前登录人部门及子部门节点树
export const getDeptTreeByIds = (params, options) =>
  request.get('api/v4ward/dept/treeByIds', Object.assign({}, options, { params }))

// /v4ward/order/details/{orderId}xunjian

// 查询工单详情
export const getDetailByOrderId = (params, options) =>
  request.get(`api/v4ward/order/details/${params}`, Object.assign({}, options, { params }))

// 根据设备和工单查询任务明细
export const getTaskListByOrderAndDevice = (params, options) =>
  request.get(`api/deviceinspecttasklist/getTaskListByOrderAndDevice`, Object.assign({}, options, { params }))

// 巡检工单提交巡检任务
export const commitTaskList = (params, options) =>
  request.get(`api/deviceinspecttasklist/commitTaskList`, Object.assign({}, options, { params }))


// 根据项目获取耗材集合
export const getConsumableList = (params, options) =>
  request.get(`api/v4ward/consumable/getConsumableList`, Object.assign({}, options, { params }))

// 维修提交
export const addRepair = (params, options) =>
  request.post(`api/v4ward/repair/task/device/addRepair`, params, options)

// 获取当前登录人部门及子部门人员
export const getMaintenceUserList = (params, options) =>
  request.get(`/api/v4ward/user/userList`, Object.assign({}, options, { params }))









// 报修服务类型接口

// 根据工单类型获取所有服务项目 /orderserviceitem/getItemByModuleType
export const getItemByModuleType = (params, options) =>
  request.get(`/api/orderserviceitem/getItemByModuleType`, Object.assign({}, options, { params }))

// 根据项目获取设备
export const getDeviceId = (params, options) =>
  request.get('/api/device/queryList', Object.assign({}, options, { params }));

// pc工单详情显示服务项目 /orderserviceitemlistrecord/detailByOrderId
export const getServiceProjectByOrderId = (params, options) =>
  request.get('/api/orderserviceitemlistrecord/detailByOrderId', Object.assign({}, options, { params }));

// pc工单详情修改服务项目 /orderserviceitemlistrecord/detailByOrderId
export const editServiceProject = (params, options) =>
  request.post(`/api/orderserviceitemlistrecord/updateByOrderId`, params, options)

// 是否显示修改维修项目按钮接口 /v4ward/role/project/setting/isExecutePermission
export const isExecutePermission = (params, options) =>
  request.get('/api/v4ward/role/project/setting/isExecutePermission', Object.assign({}, options, { params }));


// 维修工单修改 /v4ward/order/repair/update
export const repairUpdate = (params, options) =>
  request.post('/api/v4ward/order/repair/update', params, options)


//     获取当前登录人部门及子部门节点树/v4ward/dept/treeByIds
export const treeByIds = (params, options) =>
    request.get('/api/v4ward/dept/treeByIds', Object.assign({}, options, { params }));

// 获取所属部门下拉框数据
export const treeByProjectDeptId = (params, options) =>
  request.get('/api/v4ward/dept/treeByProjectDeptId', Object.assign({}, options, { params }));
